import { CommandGroup, CommandItem } from "./command";
import { ExitIcon, GearIcon } from "@radix-ui/react-icons";

export interface PersonalAccountProps {
  /** When omitted, the settings entry is hidden (e.g. restricted roles). */
  onSettingsClick?: () => void;
  onLogout: () => void;
  settingsLabel?: string;
  logoutLabel?: string;
  heading?: string;
}

export function PersonalAccount({
  onSettingsClick,
  onLogout,
  settingsLabel = "Account Preferences",
  logoutLabel = "Disconnect",
  heading = "Settings",
}: PersonalAccountProps) {
  return (
    <CommandGroup heading={heading}>
      {onSettingsClick && (
        <CommandItem
          onSelect={onSettingsClick}
          className="cursor-pointer text-sm gap-2 flex font-medium text-muted-foreground items-center"
        >
          <GearIcon className="h-4 w-4" />
          {settingsLabel}
        </CommandItem>
      )}
      <CommandItem
        onSelect={onLogout}
        className="cursor-pointer text-sm gap-2 flex font-medium text-muted-foreground items-center"
      >
        <ExitIcon className="h-4 w-4" />
        {logoutLabel}
      </CommandItem>
    </CommandGroup>
  );
}